export const SUMMARY_TYPE_OPTIONS = [
  { value: 'Simple', label: 'Simple' },
  { value: 'Detailed', label: 'Detailed' },
  { value: 'Comprehensive', label: 'Comprehensive' },
];

export const TONE_OPTIONS = [
  { value: 'Neutral', label: 'Neutral' },
  { value: 'Actionable', label: 'Actionable' },
  { value: 'Academic', label: 'Academic' },
  { value: 'Conversational', label: 'Conversational' },
  { value: 'Funny', label: 'Funny' },
];

export const FORMAT_OPTIONS = [
  { value: 'Paragraph', label: 'Paragraph' },
  { value: 'Bullet Points', label: 'Bullet Points' },
  { value: 'Numbered List', label: 'Numbered List' },
  { value: 'Outline', label: 'Outline' },
];

export const LANGUAGE_OPTIONS = [
  { value: 'English', label: 'English' },
  { value: 'Spanish', label: 'Spanish' },
  { value: 'French', label: 'French' },
  { value: 'German', label: 'German' },
  { value: 'Italian', label: 'Italian' },
  { value: 'Portuguese', label: 'Portuguese' },
  { value: 'Chinese', label: 'Chinese' },
  { value: 'Japanese', label: 'Japanese' },
  { value: 'Hindi', label: 'Hindi' },
  { value: 'Arabic', label: 'Arabic' },
  { value: 'Russian', label: 'Russian' },
  { value: 'Korean', label: 'Korean' },
];

export const FILE_SIZE_LIMITS = {
  audio: {
    type: 'Audio',
    extensions: ['mp3'],
    size: 100 * 1024 * 1024, // 100MB
    displaySize: '100MB',
  },
  video: {
    type: 'Video',
    extensions: ['mp4'],
    size: 100 * 1024 * 1024, // 100MB
    displaySize: '100MB',
  },
  document: {
    type: 'Document',
    extensions: ['pdf', 'doc', 'docx', 'txt'],
    size: 50 * 1024 * 1024, // 50MB
    displaySize: '50MB',
  },
  presentation: {
    type: 'Presentation',
    extensions: ['ppt', 'pptx'],
    size: 50 * 1024 * 1024, // 50MB
    displaySize: '50MB',
  },
};

export const PROMPT_TYPES = {
  DEFAULT: 'default',
  BLOG_POST: 'free-blog-post-generator',
  DETAILED: 'detailed',
  BRIEF: 'brief',
  KEY_POINTS: 'key-points',
};

export const SOURCE_TYPES = {
  URL: 'url',
  TEXT: 'text',
  PDF: 'pdf',
  DOCUMENT: 'document',
  PRESENTATION: 'pptx',
  AUDIO: 'audio',
  VIDEO: 'video',
  WEBPAGE: 'webpage',
};
